import { CryptoFrontendStatus } from '@/api/queryHooks/useTransactionsController';
import { Label, LabelColor } from '@/components/common';
import React from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';

const colors: Record<CryptoFrontendStatus, LabelColor> = {
  [CryptoFrontendStatus.INITIATED]: 'gray',
  [CryptoFrontendStatus.PENDING_DEPOSIT]: 'yellow',
  [CryptoFrontendStatus.DEPOSIT_RECEIVED]: 'gray',
  [CryptoFrontendStatus.CANCELLED]: 'gray',
  [CryptoFrontendStatus.EXPIRED]: 'red',
  [CryptoFrontendStatus.PAID_OUT]: 'green',
  [CryptoFrontendStatus.PAID]: 'green',
  [CryptoFrontendStatus.TX_NOT_ALLOWED]: 'red',
  [CryptoFrontendStatus.FAILED]: 'red',
  [CryptoFrontendStatus.PAYMENT_REFUNDED]: 'gray',
  [CryptoFrontendStatus.NAME_MISMATCH]: 'red',
  [CryptoFrontendStatus.REPLACED]: 'tangerine',
};

interface RowStatusProps {
  statusFromBE: CryptoFrontendStatus;
}
export const RowStatus = ({ statusFromBE }: RowStatusProps) => {
  const { isDesktop } = useMediaQuery();

  const getText = () => {
    return statusFromBE
      .split('_')
      .map((el) => {
        const word = el.toLowerCase();
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  };

  return (
    <Label size={isDesktop ? 'big' : 'small'} color={colors[statusFromBE]} icon="base">
      {getText()}
    </Label>
  );
};
